import web from "@/core/middlewares/web";

let TeamMembersIndex = () => import(/* webpackChunkName: "team-members" */ '@/views/team-members/Index');
let TeamMembersCreate = () => import(/* webpackChunkName: "team-members" */ '@/views/team-members/Create');
let TeamMembersEdit = () => import(/* webpackChunkName: "team-members" */ '@/views/team-members/Edit');

export default [
    {
        path: "/team-members",
        name: "team-members.index",
        component: TeamMembersIndex,
        meta: {
            middleware: web,
            permissions: ['team-members:viewAny'],
            title: "اعضای تیم"
        }
    },
    {
        path: "/team-members/create",
        name: "team-members.create",
        component: TeamMembersCreate,
        meta: {
            middleware: web,
            permissions: ['team-members:create'],
            title: "ایجاد عضو"
        }
    },
    {
        path: "/team-members/:id",
        name: "team-members.edit",
        component: TeamMembersEdit,
        meta: {
            middleware: web,
            permissions: ['team-members:view','team-members:update'],
            title: "ویرایش عضو"
        }
    },
]
